const API_URL = process.env.VUE_APP_API_URL+'/office'

import { userService } from './userServices.js';
import { imgApi } from './ImgApi.js';

export const stradarioApi = {getCivicoByName,
    getCivico,getDatiServizio,saveCivico,getPrgCivico,getCivicoByPrgInd,getPrimoCivicoAc
    
};

function getPrimoCivicoAc(prgAc) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgAc})
    };

    const url=API_URL + '/stradario/getPrimoCivicoAc';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                    const foto=[];
                    imgApi.formatFoto(ret.data.fotoHash,foto);
                    ret.data.foto=foto;
                return ret;
            }

            return Promise.reject();
        });
}
function getCivicoByName(prgAc,nc) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgAc,nc})
    };

    const url=API_URL + '/stradario/getCivicoByName';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
            if (ret) {
                    if (ret.outCome=='OK'){

                    
                    const foto=[];
                    imgApi.formatFoto(ret.data.fotoHash,foto);
                    ret.data.foto=foto;
                }
                return ret;
            }

            return Promise.reject();
        });
}

function getPrgCivico(prgAc,nc) {
    const comune = userService.getStoreCurrentComune();
    const sid = userService.getSessionId()
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgAc,nc})
    };

    const url=API_URL + '/stradario/getPrgCivico';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
           if (ret){
            return ret;
           }
          
         
            return 'errore';
        });
}


function getDatiServizio() {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune})
    };

    const url=API_URL + '/stradario/getDatiServizio';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function saveCivico(civico) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,civico})
    };

    const url=API_URL + '/stradario/saveCivico';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {

                return ret;
            }

            return Promise.reject();
        }).catch(()=>{
            
            return Promise.reject();
        });
}

function getCivico(prgNe) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgNe})
    };

    const url=API_URL + '/stradario/getCivico';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {
                    const foto=[];
                    imgApi.formatFoto(ret.data.fotoHash,foto);
                    ret.data.foto=foto;
                
    
                return ret;
            }

            return Promise.reject();
        });
}
function getCivicoByPrgInd(prgIndirizzo) {
    const sid = userService.getSessionId()
    const comune = userService.getStoreCurrentComune();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune,prgIndirizzo})
    };

    const url=API_URL + '/stradario/getCivico';
    //alert(JSON.stringify(url))
    return fetch(url, requestOptions).then(userService.handleResponse)
        .then(ret => {
          
          
            if (ret) {
                const foto=[];
                imgApi.formatFoto(ret.data.foto,foto);
                ret.data.foto=foto;
            

            return ret;
        }

            return Promise.reject();
        });
}
